import { render, staticRenderFns } from "./on-page-help.vue?vue&type=template&id=00ab0d7e"
import script from "./on-page-help.vue?vue&type=script&lang=ts"
export * from "./on-page-help.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports